
import { Component, Vue } from 'vue-property-decorator'
@Component({
    name: 'globalHeaderNav',
})
export default class extends Vue {
    get onlyShowNav() {
        const name = this.$route.name as string
        return ['feedback', 'SearchResult', 'allVideo', 'allDocument'].includes(name)
    }
}

